import React from 'react';
import ReactDOM from 'react-dom';
import unregister from './registerServiceWorker';
import App from './components/App';
import { SESSION_IDLE_MINUTES } from './config';
import UseAuthTimer from './hooks/UseAuthTimer';

const AppWrapper = () => {
  return (
    <div>
      <UseAuthTimer timeout={+SESSION_IDLE_MINUTES} />
      <App />
    </div>
  );
};

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

unregister();



// WEBPACK FOOTER //
// ./src/index.js